import { WagmiAdapter } from "@reown/appkit-adapter-wagmi";
import { createAppKit } from "@reown/appkit/react";
import {
  bsc,
  bscTestnet,
  defineChain,
  type AppKitNetwork,
} from "@reown/appkit/networks";
import { isDevelopment, walletConnectProjectId } from "./env";
console.log("isDevelopment", isDevelopment);
const projectId = walletConnectProjectId || "YOUR_PROJECT_ID";
export const ccChainId = 2500;
export const ccRpcUrl = "https://rpc.consciousnesschain.com";
export const ccExplorerUrl = "https://cccscan.org";

export const ccMainnet = /*#__PURE__*/ defineChain({
  id: ccChainId,
  caipNetworkId: `eip155:${ccChainId}`,
  chainNamespace: "eip155",
  name: "Conscious Chain",
  nativeCurrency: { name: "Conscious Chain Coin", symbol: "CCC", decimals: 18 },
  rpcUrls: {
    default: { http: [ccRpcUrl] },
  },
  blockTime: 300,
  blockExplorers: {
    default: {
      name: "Conscious Chain Explorer",
      url: ccExplorerUrl,
    },
  },
  testnet: false,
});

export const bscChainId = isDevelopment ? bscTestnet.id : bsc.id;
const networks: [AppKitNetwork, ...AppKitNetwork[]] = isDevelopment
  ? [bscTestnet, ccMainnet]
  : [bsc, ccMainnet];
const metadata = {
  name: "TradingSkill",
  description: "TradingSkill DApp on BSC",
  url:
    typeof window !== "undefined"
      ? window.location.origin
      : "https://tradingskill.ai",
  icons: ["/favicon.ico"],
};

const wagmiAdapter = new WagmiAdapter({
  networks,
  projectId,
});

createAppKit({
  adapters: [wagmiAdapter],
  networks,
  projectId,
  metadata,
  features: {
    analytics: false,
    email: false,
    socials: false,
  },
  themeMode: "dark",
});

export const wagmiConfig = wagmiAdapter.wagmiConfig as any;
